import * as React from 'react';
import { graphql } from 'react-apollo';
import { compose, withState, withHandlers } from 'recompose';
import { Auth } from 'aws-amplify';
import { GetUser, UpdateUser } from '../../queries/user';
import { withRouter } from 'react-router';
import Routes from '../../constants/Routes';
import { withLoggedInRedirect } from '../../helpers/withLoggedInRedirect';
import MainLayout from '../Layouts/MainLayout';

type Props = {
  props: any;
  login: () => void;
  username: string;
  password: string;
  updateUsername: (event: React.FormEvent<HTMLInputElement>) => void;
  updatePassword: (event: React.FormEvent<HTMLInputElement>) => void;
};

const CustomLogin: React.SFC<Props> = ({
  login,
  username,
  password,
  updateUsername,
  updatePassword,
}) => (
  <MainLayout>
    <p>Custom Login</p>
    <form onSubmit={login}>
      <input placeholder="Username" type="text" value={username} onChange={updateUsername} />
      <br />
      <input placeholder="Password" type="password" value={password} onChange={updatePassword} />
      <br />
      <button type="submit">Login</button>
    </form>
  </MainLayout>
);

export default compose(
  withRouter,
  withLoggedInRedirect,
  graphql(UpdateUser, {
    options: {
      update: (dataProxy, { data }: { data: any }) => {
        dataProxy.writeQuery({ query: GetUser, data: { user: data.updateUser } });
      },
    },
    props: (props: any) => ({
      onUpdate: (user: any) => {
        props.mutate({ variables: user });
      },
    }),
  }),
  withState('username', 'setUsername', ''),
  withState('password', 'setPassword', ''),
  withHandlers({
    updateUsername: ({ setUsername }) => (event: React.FormEvent<HTMLInputElement>) =>
      setUsername(event.currentTarget.value),
    updatePassword: ({ setPassword }) => (event: React.FormEvent<HTMLInputElement>) =>
      setPassword(event.currentTarget.value),
    login: ({ username, password, onUpdate, history }) => async (event: any) => {
      event.preventDefault();
      try {
        const user = await Auth.signIn(username, password);
        console.log('CHALLENGE', user.challengeName || 'no challenge found');
        console.log('user:', user);
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          console.log('new password required');
        } else if (user.challengeName === 'SMS_MFA') {
          console.log('SMS MFA sent');
        } else {
          const { payload } = user.signInUserSession.getIdToken();
          const userInfo = {
            userId: payload.sub,
            loggedIn: true,
            email: payload.email,
            phone: payload.phone_number,
          };
          console.log('userInfo');
          console.log(userInfo);
          onUpdate(userInfo);
          history.push(Routes.main);
        }
      } catch (error) {
        console.log('withLogin:error', error);
        if (error.code === 'UserNotFoundException') {
          console.log('user not found');
        } else if (error.code === 'NotAuthorizedException') {
          console.log('user not authorized');
        }
      }
    },
  }),
)(CustomLogin);



// WEBPACK FOOTER //
// ./src/containers/Auth/Login.tsx